var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseBarTran90',{attrs:{"name":_vm.name,"xAxisName":_vm.xAxisName,"seriesName":_vm.seriesName,"getDataAction":_vm.getDataAction,"isShowCloseBtn":_vm.isShowCloseBtn},on:{"SizeChange":_vm.sizeChange,"StateChange":_vm.stateChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }